import {
  InvoiceStatus,
  IWorkLog,
  IWorkLogCreate,
  IWorkLogUpdate,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";
import { WSService } from "../utils/WSService";
import { ApiSortDirection } from "../utils/serviceHelper";

const service = new WSService("/payments/work-log");

export async function createWorkLog(
  request: IWorkLogCreate
): Promise<IWorkLog> {
  const { data } = await service.post("", request);
  return data;
}

export type ApiQueryListWorkLogs = {
  // workLogId filters
  "filter[workLogId][=]"?: string;
  "filter[workLogId][!=]"?: string;
  "filter[workLogId][in]"?: string[];
  "filter[workLogId][notIn]"?: string[];

  // workLogNumber filters
  "filter[workLogNumber][=]"?: string;
  "filter[workLogNumber][!=]"?: string;
  "filter[workLogNumber][in]"?: string[];
  "filter[workLogNumber][notIn]"?: string[];

  // status filters
  "filter[status][=]"?: WorkLogStatus;
  "filter[status][!=]"?: WorkLogStatus;
  "filter[status][in]"?: WorkLogStatus[];
  "filter[status][notIn]"?: WorkLogStatus[];

  // payerId filters
  "filter[payerId]"?: string;

  // payeeId filters
  "filter[payeeId]"?: string;
  "filter[payeeId][in]"?: string[];
  "filter[payeeId][notIn]"?: string[];

  // payerPayeeEngagementId filters
  "filter[payerPayeeEngagementId][=]"?: string;
  "filter[payerPayeeEngagementId][in]"?: string[];

  // engagementId filters
  "filter[engagementId][=]"?: string;
  "filter[engagementId][in]"?: string[];

  // startDate filters
  "filter[startDate][=]"?: Date;
  "filter[startDate][>]"?: Date;
  "filter[startDate][>=]"?: Date;
  "filter[startDate][<]"?: Date;
  "filter[startDate][<=]"?: Date;

  // endDate filters
  "filter[endDate][=]"?: Date;
  "filter[endDate][>]"?: Date;
  "filter[endDate][>=]"?: Date;
  "filter[endDate][<]"?: Date;
  "filter[endDate][<=]"?: Date;
  "filter[endDate][exists]"?: boolean;

  // createdAt filters
  "filter[createdAt][=]"?: Date;
  "filter[createdAt][>]"?: Date;
  "filter[createdAt][>=]"?: Date;
  "filter[createdAt][<]"?: Date;
  "filter[createdAt][<=]"?: Date;

  // updatedAt filters
  "filter[updatedAt][=]"?: Date;
  "filter[updatedAt][>]"?: Date;
  "filter[updatedAt][>=]"?: Date;
  "filter[updatedAt][<]"?: Date;
  "filter[updatedAt][<=]"?: Date;

  // Sorting
  "sort[createdAt]"?: ApiSortDirection;
  "sort[updatedAt]"?: ApiSortDirection;
  "sort[startDate]"?: ApiSortDirection;
  "sort[endDate]"?: ApiSortDirection;

  page?: {
    size?: number;
    number?: number;
  };
};

export async function listWorkLogs(
  query?: ApiQueryListWorkLogs
): Promise<IWorkLog[]> {
  const { data } = await service.get("", { params: query });
  return data;
}

export type IWorkLogsSummary = {
  listSize: number;
  totalAmount: number;
};

export async function getWorkLogsSummary(
  query?: ApiQueryListWorkLogs
): Promise<IWorkLogsSummary> {
  const { headers } = await service.get("", { params: query });

  return {
    listSize: Number(headers["x-ws-list-size"]),
    totalAmount: Number(headers["x-ws-custom-worklog-amount-total"])
  };
}

export async function getWorkLog(workLogId: string): Promise<IWorkLog> {
  const { data } = await service.get("/" + workLogId);
  return data;
}

export type ApiQueryConvertWorkLog = {
  invoiceStatus?: InvoiceStatus;
};

export async function convertWorkLog(
  workLogId: string,
  query?: ApiQueryConvertWorkLog
): Promise<IWorkLog> {
  const { data } = await service.post("/" + workLogId + "/convert", undefined, {
    params: query
  });
  return data;
}

export async function updateWorkLog(
  workLogId: string,
  request: IWorkLogUpdate
): Promise<IWorkLog> {
  const { data } = await service.patch("/" + workLogId, request);
  return data;
}
